import { LoadingElement } from "@pinkyhead/dovekit"
import { Container } from "./ParticipationsLoading.styles"

export const ParticipationsLoading = () => {
  return (
    <Container>
      <LoadingElement width="90px" height="50px" />
      <LoadingElement width="140px" />
      <LoadingElement width="40px" />
    </Container>
  )
}
